import { FC } from "react";
import { HoverCard, Text } from "@mantine/core";

interface HoverTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  withArrow?: boolean;
}

/**
 * A component that looks like a tooltip but remains open when hovering over the tooltip content.
 *
 * @param children the content that will be displayed
 * @param content the content that will be displayed when hovering over the tooltip
 * @param withArrow whether or not to display an arrow on the tooltip
 */
export const HoverTooltip: FC<HoverTooltipProps> = ({
  children,
  content,
  withArrow = true,
}) => {
  return (
    <HoverCard position="top" withArrow={withArrow} arrowSize={5}>
      <HoverCard.Target>{children}</HoverCard.Target>
      <HoverCard.Dropdown variant="tooltip">
        <Text fz="sm" c="white">
          {content}
        </Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
